import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.site_feature_grant_source_ */
export type SiteFeatureGrantSourceId = string & {
  __brand: 'SiteFeatureGrantSourceId'
}

/** Represents the table public.site_feature_grant_source_ */
export default interface SiteFeatureGrantSourceTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<
    SiteFeatureGrantSourceId,
    SiteFeatureGrantSourceId,
    SiteFeatureGrantSourceId
  >

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type SiteFeatureGrantSource = Selectable<SiteFeatureGrantSourceTable>

export type SiteFeatureGrantSourceInitializer =
  Insertable<SiteFeatureGrantSourceTable>

export type SiteFeatureGrantSourceMutator =
  Updateable<SiteFeatureGrantSourceTable>

export const siteFeatureGrantSourceId =
  z.string() as unknown as z.Schema<SiteFeatureGrantSourceId>

export const siteFeatureGrantSource = z.object({
  id: siteFeatureGrantSourceId,
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<SiteFeatureGrantSource>

export const siteFeatureGrantSourceInitializer = z.object({
  id: siteFeatureGrantSourceId,
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SiteFeatureGrantSourceInitializer>

export const siteFeatureGrantSourceMutator = z.object({
  id: siteFeatureGrantSourceId.optional(),
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SiteFeatureGrantSourceMutator>
